import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import { resolveZIndex } from 'components/base';
import {
  BORDER_WIDTH,
  PADDING,
  SCREEN_SIZE,
  type Size,
  useTheme,
} from 'design-system/theme';
import { useIsSmallerThan } from 'hooks/useResponsive';
import type { PropsWithChildren } from 'react';
import { useWindowDimensions } from 'react-native';

export interface CardProps {
  border?: boolean;
  color?: ColorName;
  paddingVertical?: number;
  paddingHorizontal?: number;
  borderColor?: ColorName;
  hasThickBorder?: Boolean;
  unsetZIndex?: boolean;
  overflow?: 'hidden' | 'visible';
}

export const Card = styled.View<PropsWithChildren<CardProps>>(
  ({
    border = false,
    color = 'base-grey',
    borderColor = 'divider',
    hasThickBorder = false,
    paddingHorizontal = PADDING.m,
    paddingVertical = PADDING.s,
    unsetZIndex = false,
    overflow,
  }) => {
    const theme = useTheme();
    const backgroundColor = theme.color[color];
    const borderTopColor = theme.color[borderColor];
    const borderWidth = hasThickBorder ? BORDER_WIDTH[2] : BORDER_WIDTH[1];
    const borderTopWidth = border ? borderWidth : 0;
    const zIndex = resolveZIndex(unsetZIndex);

    return {
      width: '100%',
      paddingHorizontal,
      paddingVertical,
      backgroundColor,
      borderTopColor,
      borderStyle: 'solid',
      borderTopWidth,
      zIndex,
      overflow,
    };
  },
);

export interface ExtendedCardProps {
  maxSize?: Size;
}

export const ExtendedCard = styled(Card)<ExtendedCardProps>(
  ({ maxSize = 'md' }) => {
    const { width } = useWindowDimensions();
    const isSmall = useIsSmallerThan(maxSize);

    const responsiveWidth = isSmall ? width : SCREEN_SIZE[maxSize];
    const resolvedWidth = responsiveWidth * 0.8;

    return {
      width: resolvedWidth,
    };
  },
);
